import React, { useEffect, useState } from "react";
import { FaBook, FaPlay, FaQuestionCircle, FaUsers } from "react-icons/fa";
import { AdminService } from "../../../app/service/admin.service";
import { toast } from "react-toastify";

const ExamDashboard = () => {
  const [stats, setStats] = useState({
    totalExams: 0,
    activeExams: 0,
    totalQuestions: 0,
    totalStudents: 0,
  });

 

   useEffect(() => {
      getRegisters();
    }, []);
  
    const getRegisters = () => {
      const data = {
        search: "",
        start: 1,
        count: 10,
        type: "registerNow",
      };
      AdminService.getExamDashboardStats(data).then((res: any) => {
        if (res.status === "Success") {
          setStats(res.data);
        } else {
          toast.error(res.message);
        }
      });
    };

  return (
    <div className="exam-dashboard">
      <h2>Exam Dashboard</h2>

      <div className="stats-grid">
        {/* <div className="card">
          <FaBook />
          <h3>{stats.totalExams}</h3>
          <p>Total Exams</p>
        </div> */}

        {/* <div className="card">
          <FaPlay />
          <h3>{stats.activeExams}</h3>
          <p>Active Exams</p>
        </div> */}

        <div className="card">
          <FaQuestionCircle />
          <h3>{stats.totalQuestions}</h3>
          <p>Questions</p>
        </div>

        <div className="card">
          <FaUsers />
          <h3>{stats.totalStudents}</h3>
          <p>Students</p>
        </div>
      </div>
    </div>
  );
};

export default ExamDashboard;
